// Prefer the attachment-disposition URL; only allow https to avoid javascript: injection.
export const getInvoiceDownloadHref = invoice => {
  const href = invoice?.pdf_download_url || invoice?.pdf_url;
  return href?.startsWith('https://') ? href : null;
};
